import React from 'react'
import { ABHICASH_LIKE, CHECK_COMPANY_TENANT, Company_DATA } from '../../../../../../layouts/MainTenantconfig'
const Bank = ({ pageNumber, refresh, selectAll, paginationHandler, admin, changehandler, allUserDetail, paymentAndVerificationHandler, paymentData, ApplicationId, loanIdData, selectednbfcFilter, nbfcList, handleNBfc, selectAllBtn, penaltyMethodOption, handlerPenaltyOption, tenant }) => {

    return (

        <div className="container-fluid">
            <div className="row form-group">
                <div className="col-xs-12">
                    <h3 className="text-center blue-text">Disburse By ICICI Bank</h3>
                </div>
            </div>
            <div className="row form-group" style={{ margin: '20px 0' }}>
                <div className="col-xs-12 col-sm-3">
                    <label>NBFC</label>
                    <select className='form-control' value={selectednbfcFilter} onChange={(e) => handleNBfc(e)}>
                        <option value=''>Select value</option>
                        {
                            nbfcList && nbfcList?.length > 0 ?
                                nbfcList?.map((value, index) => {
                                     if(value?.nbfcId == "emTYxWtA") return null;
                                    return (
                                        <option value={value?.nbfcId}>{value?.name}</option>
                                    )
                                })
                                : ''}

                    </select>
                </div>
                {
                    selectednbfcFilter !== "" ?
                        <div className="col-xs-12 col-sm-6 text-center">
                            <div className="" style={{ display: 'inline-flex' }}>
                                <div className="" >
                                    {
                                       CHECK_COMPANY_TENANT(ABHICASH_LIKE) ?
                                            <button className='profile-save-btn' onClick={() => handlerPenaltyOption(true, "")}>Verify Payment</button>
                                            :
                                            <button className='profile-save-btn' onClick={() => paymentAndVerificationHandler('verify')}>Verify Payment</button>
                                    }
                                </div>
                                &nbsp;
                                <div className="col-xs-12 col-sm-3">
                                    <button className='payment-btn' onClick={() => paymentAndVerificationHandler('payment')} >Make Payment</button>

                                </div>
                            </div>
                        </div>
                        : ''}
                <div className="col-xs-12 col-sm-3">


                </div>
            </div>
            {
                selectednbfcFilter !== "" ?
                    <>
                        <div className='row text-center'>
                            <div className='col-sm-2'>
                                <label style={{ fontSize: '18px' }}>Select All </label>&nbsp;&nbsp;
                                <input type='checkbox' onChange={(e) => selectAll(e)} checked={selectAllBtn ? true : false} />
                            </div>
                            <div className='col-sm-8 text-end'>
                            </div>
                            <div className='col-sm-2 text-end'>
                                <button className='profile-save-btn' onClick={() => refresh()}>Refresh</button>
                            </div>
                        </div>
                        <div className='row'>

                            <div className='col-sm-12 col-xs-12'>
                                <div>
                                    <div className="overflow-x-auto">

                                        <table className="phocket-table">
                                            <thead>
                                                {
                                                   CHECK_COMPANY_TENANT(ABHICASH_LIKE) ?
                                                        <tr>
                                                           
                                                            <th>Application id</th>
                                                            <th>Name</th>
                                                            <th>Mobile Number</th>
                                                            <th>Email Id</th>
                                                            <th>Aadhar Number</th>
                                                            <th>Approved Date</th>
                                                            <th>Loan Amt</th>
                                                            <th>Pro. Fee</th>
                                                            <th>Net Payment</th>
                                                            <th>A/c No.</th>
                                                            <th>IFSC Code</th>
                                                            <th>Bank Name</th>
                                                            <th>State</th>
                                                            <th>Tenure</th>
                                                            <th>Make Payment/Verify Payment</th>
                                                            {paymentData !== '' ?
                                                                <th>Payment Status</th>
                                                                : ""}

                                                        </tr>
                                                        :
                                                        <tr>
                                                            <th>EMI Type</th>
                                                            <th>Loan Id</th>
                                                            <th>application id</th>
                                                            <th>Name</th>
                                                            <th>Approved Date</th>
                                                            <th>Loan Amt</th>
                                                            <th>Pro. Fee</th>
                                                            <th>Net Payment</th>
                                                            <th>Bank Name</th>
                                                            <th>A/c No.</th>
                                                            <th>IFSC Code</th>
                                                            <th>Make Payment/Verify Payment</th>
                                                            {paymentData !== '' ?
                                                                <th>Payment Status</th>
                                                                : ""}

                                                        </tr>
                                                }
                                            </thead>
                                            <tbody>
                                                {allUserDetail ? allUserDetail.map((data, i) => {
                                                    return (
                                                        <>
                                                            {
                                                               CHECK_COMPANY_TENANT(ABHICASH_LIKE) ?
                                                                    <tr key={i}>
                                                                        <td>{data.applicationId}</td>
                                                                        <td style={{ whiteSpace: 'break-spaces' }}>{data.userName}</td>
                                                                        <td>{data.mobileNumber}</td>
                                                                        <td>{data.emailId}</td>
                                                                        <td>{data.aadharNumber}</td>
                                                                        <td>{data.approveDate}</td>
                                                                        <td>{data.loanAmount}</td>
                                                                        <td>{data.processingFee}</td>
                                                                        <td>{data.netdisbursmentAmount}</td>
                                                                        <td>{data.accountNo}</td>
                                                                        <td>{data.ifscCode}</td>
                                                                        <td>{data.bankName}</td>
                                                                        <td>{data.state}</td>
                                                                        <td>{data.loanEmi}</td>
                                                                        <td><input id={'disburseIcici' + i} type='checkbox' onChange={(e) => changehandler(e, data)} /></td>
                                                                        {paymentData !== '' ? Object.keys(paymentData).includes(data.loanId) ?
                                                                          
                                                                            <td>{(paymentData[data.loanId]) !== null && (paymentData[data.loanId]) !== undefined ? Object.values(paymentData[data.loanId]) : "null"}</td>
                                                                            : "" : ""}
                                                                       

                                                                    </tr>
                                                                    :
                                                                    <tr key={i}>
                                                                        <td>{data.loanEmi}</td>
                                                                        <td>{data.applicationLoanId}</td>
                                                                        <td>{data.applicationId}</td>
                                                                        <td style={{ whiteSpace: 'break-spaces' }}>{data.userName}</td>
                                                                        <td>{data.approveDate}</td>
                                                                        <td>{data.loanAmount}</td>
                                                                        <td>{data.processingFee}</td>
                                                                        <td>{data.netdisbursmentAmount}</td>
                                                                        <td>{data.bankName}</td>
                                                                        <td>{data.accountNo}</td>
                                                                        <td>{data.ifscCode}</td>
                                                                        <td><input id={'disburseIcici' + i} type='checkbox' onChange={(e) => changehandler(e, data)} /></td>
                                                                        {paymentData !== '' ? Object.keys(paymentData).includes(data.loanId) ?
                                                                            // console.log((paymentData[data.loanId]))
                                                                            <td>{(paymentData[data.loanId]) !== null && (paymentData[data.loanId]) !== undefined ? Object.values(paymentData[data.loanId]) : "null"}</td>
                                                                            : "" : ""}
                                                                        {/* {Object.keys(ids).includes(data.loanId) ?
                                                    <td>{Object.values(ids[data.loanId])}</td>
                                                    : ""} */}
                                                                        {/* <td></td> */}

                                                                    </tr>
                                                            }
                                                        </>

                                                    )
                                                }) : ""}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-4 col-xs-12 no-padding"> <button type="button" className="btn btn-default fa fa-chevron-left btn-lg btn-block mage" id="backword" onClick={e => paginationHandler('left')}><span className="fa fa-chevron-left" /></button></div>
                                <div className="col-sm-4 col-xs-12  phoc text-center" >On this Page:<b>{allUserDetail.length}</b>&nbsp;&nbsp; PageNumber: <b>{pageNumber}</b></div>
                                <div className="col-sm-4 col-xs-12 no-padding"> <button type="button" className="btn btn-default fa fa-chevron-right btn-lg btn-block mage" id="forword" onClick={e => paginationHandler('right')}><span className="fa fa-chevron-right" /></button></div> </div>
                        </div>
                    </> : ''}

            {
                penaltyMethodOption?.show ?
                    <div className="background-blur">

                        <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px' }}>
                            <i onClick={() => handlerPenaltyOption(false, "")} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                            <div className="row from-group">
                                <div className="col-xs-12" style={{ padding: '10px' }}>
                                    <h4 className="text-center" style={{ marginBottom: '10px', marginTop: '10px' }}>Penalty Method</h4>
                                </div>
                            </div>
                            <div className="row from-group" style={{ marginTop: '20px' }}>
                                <div className="col-xs-12 col-xs-12">
                                    <select className='form-control' onChange={(e) => handlerPenaltyOption(true, e.target.value)} >
                                        <option value={""}>Select</option>
                                        {/* <option value={"v1"}>V1</option> */}
                                        <option value={"v2"}>V2</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row from-group text-center" style={{ marginTop: '30px' }}>
                                <div className="col-xs-12">
                                    <button className="btn btn-primary" style={{ marginTop: '10px', borderRadius: '5px', border: '1px solid #D3D9E9', boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', background: '#2B78FF' }} disabled={penaltyMethodOption?.penaltyMethod == null || penaltyMethodOption?.penaltyMethod == undefined || penaltyMethodOption?.penaltyMethod == "" ? true : false} onClick={() => paymentAndVerificationHandler('verify')}>Apply</button>                         </div>

                            </div>
                        </div>
                    </div>
                    : ""}
        </div>
    )
}
export default Bank